module.exports = _dll_vue;